import type { CommunityMemberSelectVariantProps } from "./CommunityMemberSelectCompassComponent";
import { CommunityMemberSelectView } from "./CommunityMemberSelectView";
import { useCommunityMemberContainsSearch } from "./useCommunityMemberContainsSearch";

// Opt-in substring-matching variant for surfaces that pass searchMode="contains".
// Remove alongside CommunityMemberSelectLegacyVariant once
// crm_clickhouse_contacts_search_pickers_enabled is enabled for all communities.
export const CommunityMemberSelectContainsVariant = (
  props: CommunityMemberSelectVariantProps,
) => {
  const searchState = useCommunityMemberContainsSearch({
    excludeAdmins: props.excludeAdmins,
    filters: props.filters,
    getCommunityMemberText: props.getCommunityMemberText,
    includeInactive: props.includeInactive,
    valueField: props.valueField,
  });

  return <CommunityMemberSelectView {...props} {...searchState} />;
};
